import { SearchRowProfile } from "@wingspanhq/wingspan-api-sdk";

type SearchRow = {
  profile?: SearchRowProfile;
};

export const selectorSearchRowSecondaryName = (
  row: SearchRow
): string | undefined => row.profile?.resolvedSecondaryName ?? undefined;
